import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { GetItemsByCategory } from "../../api/requests/Api";
import { Item } from "../../entity/Entity";
import "./Items.css";

const Items = () => {
    const [items, setItems] = useState<Item[]>([]);
    const [filteredItems, setFilteredItems] = useState<Item[]>([]);
    const [availableTags, setAvailableTags] = useState<string[]>([]);
    const [activeTags, setActiveTags] = useState<string[]>([]);

    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const categoryId = searchParams.get("category");

    useEffect(() => {
        if (categoryId) {
            fetchItems(categoryId);
        } else {
            setLoading(false);
            setItems([]);
            setFilteredItems([]);
        }
    }, [categoryId]);

    const fetchItems = async (category: string) => {
        try {
            setLoading(true);
            const data = await GetItemsByCategory(category);

            setItems(data);
            setFilteredItems(data);

            // Extract unique tags from items
            const tagSet = new Set<string>();
            data.forEach(item => {
                item.tags?.forEach(tag => tag === "test" ? {} : tagSet.add(tag));
            });

            setAvailableTags(Array.from(tagSet));
            setActiveTags([]);
        } catch {
            setError("Failed to load items");
        } finally {
            setLoading(false);
        }
    };

    const handleItemClick = (itemId: string) => {
        navigate(`/item?id=${itemId}`);
    };

    const toggleTag = (tag: string) => {
        let updatedTags: string[];

        if (activeTags.includes(tag)) {
            updatedTags = activeTags.filter(t => t !== tag);
        } else {
            updatedTags = [...activeTags, tag];
        }

        setActiveTags(updatedTags);

        if (updatedTags.length === 0) {
            setFilteredItems(items);
            return;
        }

        const filtered = items.filter(item =>
            updatedTags.every(tag => item.tags?.includes(tag))
        );

        setFilteredItems(filtered);
    };

    if (loading) return <div className="items-loading">Загрузка...</div>;
    if (error) return <div className="items-error">{error}</div>;

    return (
        <div className="category-container-wrapper">

            {/* TAG FILTERS */}
            {availableTags.length > 0 && (
                <div className="items-filters">
                    {availableTags.map(tag => (
                        <button
                            key={tag}
                            className={`filter-btn ${activeTags.includes(tag) ? "active" : ""}`}
                            onClick={() => toggleTag(tag)}
                        >
                            {tag}
                        </button>
                    ))}
                </div>
            )}

            {/* ITEMS GRID */}
            <div className="items-container">
                {filteredItems.length === 0 && (
                    <div className="items-empty">No items found</div>
                )}

                {filteredItems.map((item) => (
                    <div
                        key={item._id}
                        className="item-card"
                        onClick={() => handleItemClick(item._id)}
                    >
                        <img
                            src={item.images_link?.[0]}
                            alt={item.title}
                            className="item-image"
                        />
                        <div className="item-info">
                            <h3 className="item-title">{item.title}</h3>
                            <h2 className="item-title">{`${formatPrice(item.price)} ₽` }</h2>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const formatPrice = (value: number | undefined) => {
    if (!value) return "";
    return value.toLocaleString("ru-RU").replace(/,/g, " ");
};

export default Items;
